import { z } from 'zod';
/**
 * The question types the platform recognises. Also declared in
 * `apps/api/common/types/schemas.d.ts`; both sides should import from here.
 */
export const QuestionType = z.enum([
    'FREE_TEXT',
    'FREE_TEXT_PLAYGROUND',
    'PLAYGROUND',
    'LOOKER_EXTERNAL',
    'FREE_TEXT_LOOKER_EMBED',
    'TABLEAU_EXTERNAL',
    'FREE_TEXT_TABLEAU_EMBED',
    'GOOGLE_SHEETS_EXTERNAL',
    'FREE_TEXT_GOOGLE_SHEETS_EXTERNAL',
    'FREE_TEXT_POWERBI_EXTERNAL',
    'FREE_TEXT_SQL_CODE',
    'PYTHON_PLAYGROUND',
    'PYTHON_MULTIPLE_CHOICE',
    'SQL_MULTIPLE_CHOICE',
    'LLM_PLAYGROUND',
    'STRICT_TEXT',
    'FREE_TEXT_AI_VERIFIED',
    'FREE_TEXT_SELF_CHECK',
]);
/**
 * The subset the preview validator can actually evaluate.
 *
 * Narrower than `QuestionType` on purpose: preview only runs the AI-backed
 * paths. Expressing it as a subset of the same enum means adding a question
 * type cannot silently widen what preview accepts.
 */
export const AIValidatedQuestionType = z.enum([
    'LLM_PLAYGROUND',
    'FREE_TEXT_AI_VERIFIED',
]);
